import React, { useRef } from 'react';
import { Box, TextareaAutosize, Typography } from '@material-ui/core';
import { observer } from 'mobx-react';

import { useStores } from '../../hooks/use-stores';

import PreloadButton from '../../interface/PreloadButton';

const Review = observer(() => {
    const { ProfileDataStore: store } = useStores();
    const { sendReview, editLoader } = store || {};

    const reviewRef = useRef();

    const handle = e => {
        e.preventDefault();
        sendReview(reviewRef.current.value);
    };

    return (
        <>
            <form onSubmit={handle}>
                <Box display="flex" flexDirection="column">
                    <Box mb={3}>
                        <Typography variant="h6">Оставить отзыв</Typography>
                    </Box>

                    <TextareaAutosize ref={reviewRef} rowsMin={6} required placeholder="Ваше пожелание или отзыв" />

                    <Box mt={2}>
                        <PreloadButton isLoad={editLoader}>Отправить</PreloadButton>
                    </Box>
                </Box>
            </form>
        </>
    );
});

export default Review;
